import React, { useState, useEffect } from 'react';
import { useTheme, useThemeColors } from '../../hooks/useTheme';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import logo from '../../assets/images/logo2.png';
import './Header.scss';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header: React.FC = () => {
  const { toggleTheme } = useTheme();
  const colors = useThemeColors();
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header 
      className="header" 
      style={{
        backgroundColor: colors.surface,
        borderBottom: `1px solid ${colors.border}`
      }}
    >
      <div className="header__container">
        <div className="header__logo">
          <img 
            src={logo} 
            alt="Anantha's Logo" 
            className="header__logo-image"
          />
        </div>

        {isMobile ? (
          <>
            <button 
              className="header__menu-button"
              onClick={toggleMenu}
              aria-label="Toggle menu"
              style={{ color: colors.primary }}
            >
              {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
            
            <nav 
              className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}
              style={{
                backgroundColor: colors.surface,
                color: colors.primary
              }}
            >
              <ul>
                <li><a href="#home" onClick={toggleMenu} style={{ color: colors.primary }}>Home</a></li>
                <li><a href="#about" onClick={toggleMenu} style={{ color: colors.primary }}>About</a></li>
                <li><a href="#experience" onClick={toggleMenu} style={{ color: colors.primary }}>Experience</a></li>
                <li><a href="#education" onClick={toggleMenu} style={{ color: colors.primary }}>Education</a></li>
                <li><a href="#projects" onClick={toggleMenu} style={{ color: colors.primary }}>Projects</a></li>
                <li><a href="#contact" onClick={toggleMenu} style={{ color: colors.primary }}>Contact</a></li>
                <li className="header__theme-toggle-mobile">
                  <ThemeToggle />
                </li>
              </ul>
            </nav>
          </>
        ) : (
          <>
            <nav className="header__nav">
              <ul>
                <li><a href="#home" style={{ color: colors.primary }}>Home</a></li>
                <li><a href="#about" style={{ color: colors.primary }}>About</a></li>
                <li><a href="#experience" style={{ color: colors.primary }}>Experience</a></li>
                <li><a href="#education" style={{ color: colors.primary }}>Education</a></li>
                <li><a href="#projects" style={{ color: colors.primary }}>Projects</a></li>
                <li><a href="#contact" style={{ color: colors.primary }}>Contact</a></li>
              </ul>
            </nav>
            <ThemeToggle />
          </>
        )}
      </div>
    </header>
  );
};

export default Header;